import { MouseEventHandler } from 'react'

type Props = {
  children?: React.ReactNode
  isOpen: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
}

function SelectableButton({ children, isOpen, onClick }: Props) {
  return (
    <button className={`btn ${isOpen ? '' : 'btn-outline'} btn-neutral btn-sm`} onClick={onClick}>
      {children}
    </button>
  )
}

export default SelectableButton
